"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var NoSSR = function NoSSR(_a) {
  var children = _a.children,
      _b = _a.fallback,
      fallback = _b === void 0 ? null : _b;

  var _c = React.useState(false),
      mounted = _c[0],
      setMounted = _c[1];

  React.useEffect(function () {
    return setMounted(true);
  }, []);

  if (!mounted) {
    return fallback;
  }

  return children;
};

exports.default = NoSSR;